<div class="modal-header">
    <h4 class="modal-title pull-left">Share Listing</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
    </button> 
</div>
<div class="modal-body">
    <div class="form-group">
        <label class="form-label">Email Address</label>
        <div class="textbox-date">
            <tag-input [(ngModel)]="mailIds" secondaryPlaceholder="Email Address" placeholder="+ Email IDs" [errorMessages]="errorMessages" [validators]="validators" [separatorKeyCodes]="keyCode"></tag-input>
            <h5 class="infotext">
                Use a comma or space to separate multiple email addresses
            </h5>
        </div>
    </div>
    <div class="form-group">
        <label class="form-label">Notes</label>
        <textarea class="form-control property-description" maxlength="3000" [(ngModel)]="this.sharePropertyEmailInputModel.Content"
                  rows="3"></textarea>
    </div>
    <div class="text-right">
        <button type="button" (click)="ShareProperty()" [disabled]="disableButton == false" class="btn btn-success btn-lg">Share</button>
    </div>
</div>
